import i18next from "i18next";
import PropTypes from "prop-types";
import React from "react";
import NotificationPopup from "~/assets/js/components/Popup/NotificationPopup";
import Button from "~/assets/js/components/Button";

const AddToCartSuccess = ({
    open,
    productName,
    productImage,
    onClose,
    onContinueBrowsing,
    onRedirect,
    showNonDiscountedProducts,
    discountedProducts,
    nonDiscountedProducts,
}) => {
    const text = showNonDiscountedProducts
        ? i18next.t("productDetails.greenClub.succesPopup.text", {
              discounted: discountedProducts,
              nonDiscounted: nonDiscountedProducts,
          })
        : i18next.t("productDetails.notifications.addToCart", {
              productName,
          });

    return (
        <NotificationPopup open={open} onClose={onClose} showX={false}>
            <div className="row">
                <img
                    src={productImage}
                    alt={productName}
                    className="round-img sm-image"
                    width="40"
                    height="40"
                    style={{ marginRight: "20px" }}
                />
                <span
                    dangerouslySetInnerHTML={{
                        __html: text,
                    }}
                ></span>
            </div>
            <div className="row btn-container">
                <Button
                    variant="secondary"
                    label={i18next.t(
                        "productDetails.notifications.continueShopping"
                    )}
                    onClick={onContinueBrowsing}
                    customStyle="notif-btn"
                />
                <Button
                    label={i18next.t("productDetails.notifications.goToCart")}
                    onClick={onRedirect}
                    customStyle="notif-btn"
                />
            </div>
        </NotificationPopup>
    );
};

AddToCartSuccess.propTypes = {
    open: PropTypes.bool,
    productName: PropTypes.string,
    productImage: PropTypes.string,
    onContinueBrowsing: PropTypes.func,
    onClose: PropTypes.func,
    onRedirect: PropTypes.func,
    showNonDiscountedProducts: PropTypes.bool,
    discountedProducts: PropTypes.number,
    nonDiscountedProducts: PropTypes.number,
};

export default AddToCartSuccess;
